"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var Accordion = function () {
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("h2", { className: "title-h2" }, t('FAQ.TITLE')),
        react_1.default.createElement("div", { className: "option" },
            react_1.default.createElement("input", { type: "checkbox", id: "toggle1", className: "toggle" }),
            react_1.default.createElement("label", { className: "title", htmlFor: "toggle1" },
                t('FAQ.FIRST.LABEL'),
                react_1.default.createElement("i", { className: "icon-chevron-down" })),
            react_1.default.createElement("div", { className: "content" },
                react_1.default.createElement("p", null, t('FAQ.FIRST.CONTENT')))),
        react_1.default.createElement("div", { className: "option" },
            react_1.default.createElement("input", { type: "checkbox", id: "toggle2", className: "toggle" }),
            react_1.default.createElement("label", { className: "title", htmlFor: "toggle2" },
                t('FAQ.SECOND.LABEL'),
                react_1.default.createElement("i", { className: "icon-chevron-down" })),
            react_1.default.createElement("div", { className: "content" },
                react_1.default.createElement("p", null, t('FAQ.SECOND.CONTENT')))),
        react_1.default.createElement("div", { className: "option" },
            react_1.default.createElement("input", { type: "checkbox", id: "toggle3", className: "toggle" }),
            react_1.default.createElement("label", { className: "title", htmlFor: "toggle3" },
                t('FAQ.THREE.LABEL'),
                react_1.default.createElement("i", { className: "icon-chevron-down" })),
            react_1.default.createElement("div", { className: "content" },
                react_1.default.createElement("p", null, t('FAQ.THREE.CONTENT'))))));
};
exports.default = Accordion;
